module.exports = __webpack_public_path__ + "img/10.45e15231.jpg";